export default {
  tabMenu: {
    view: 'Rozmiestnenie',
    alarm: 'Alarmy',
    loadList: 'Zoznam vsázok',
    movements: 'Pohyby',
    gantt: 'Ganttov diagram',
    loadingPlace: 'Miesto zakladania',
  },
};
